import ModalBody from './body';

export default ModalBody;